var map = {
	"./image-disclaimer_browser.png": "6054",
	"./image-disclaimer_device.png": "b1a0",
	"./logo-inst-jugendapp-300x300.png": "1891",
	"./logo-jupa-BE.png": "3163",
	"./spider-arranged-categories-de.png": "13ab",
	"./spider-arranged-categories-fr.png": "0c48",
	"./spider-circles-white.png": "2432",
	"./spider-circles.png": "7fde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a2";